import { isProdEnv, isStagingEnv } from "./util";

/**
 * Gets the base Preview URL based on the current environment
 * - Production: preview.metriport.com
 * - Staging: preview.staging.metriport.com
 * - Development/Local: localhost:3030
 */
export function getPreviewBaseUrl(): string {
  if (isProdEnv()) {
    return "https://preview.metriport.com";
  }
  if (isStagingEnv()) {
    return "https://preview.staging.metriport.com";
  }
  return "http://localhost:3030";
}

/**
 * Gets the localhost preview URL for viewing patient data
 */
export function getLocalhostPreviewUrl(): string {
  return "http://localhost:3030/v2";
}

/**
 * Gets the Bundle Explorer URL based on the current environment
 */
export function getBundleExplorerUrl(): string {
  return `${getPreviewBaseUrl()}/explore`;
}

/**
 * Builds the consolidated data filename for a patient
 * Format: {cxId}/{patientId}/{cxId}_{patientId}_CONSOLIDATED_DATA.json
 */
export function buildConsolidatedDataFileName(cxId: string, patientId: string): string {
  return `${cxId}/${patientId}/${cxId}_${patientId}_CONSOLIDATED_DATA.json`;
}
